"use client";

// A LARGE on/off switch (h-8 w-14) for the template cards — added ALONGSIDE the
// standard ui/switch (never rewriting it): the small Switch's thumb size and
// translate distance are baked into its classes, so scaling it via className
// alone would break the thumb travel. Same Radix primitive, same role="switch"
// semantics, same props — purely a bigger skin. Explicit colors (emerald when
// on, gray when off) so the state reads instantly from across the room.

import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "@/lib/utils";

const BigSwitch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      "peer inline-flex h-8 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-inner transition-colors",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-emerald-500 data-[state=unchecked]:bg-gray-300",
      className
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        "pointer-events-none block h-6 w-6 rounded-full bg-white shadow-md ring-0 transition-transform",
        "data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-0"
      )}
    />
  </SwitchPrimitive.Root>
));

BigSwitch.displayName = "BigSwitch";

export { BigSwitch };
